export function getOrganizations() {
    const results = [];
    let pagination_token = null;

    const execute_query = async PaginationToken => {
        if (PaginationToken) {
            pagination_token = PaginationToken;
        }

        // Issue the request
        return $.ajax({
            url: '/api/organization/list',
            dataType: 'json',
            data: {
                pagination_token: pagination_token
            }
        }).promise().then(organizations_json => {
            // Gather the results from this query and stash them in the output object
            for (const index in organizations_json.data.organizations) {
                results.push({
                    id: organizations_json.data.organizations[index].id,
                    name: organizations_json.data.organizations[index].name,
                    support_enabled: organizations_json.data.organizations[index].support_enabled,
                });
            }

            // Break out of this recursive loop if we've found everything
            if (organizations_json.data.pagination_token == null) {
                return results;
            }

            // If we haven't found everything, recurse again with the updated pagination token
            return execute_query(organizations_json.data.pagination_token);
        }).catch(error => {
            console.error(error);
            throw new Error('Error fetching organizations. Please try again.');
        });
    };

    return execute_query();
}
